var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticStyle:{"height":"28px","line-height":"28px","margin":"-2px -4px","text-align":"center"},style:({background: _vm.value ? _vm.value : '#fffffff'})},[_c('span',{staticStyle:{"padding":"0 5px"},style:({color: _vm.textColor})},[_vm._v(_vm._s(_vm.value))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }